import { render, staticRenderFns } from "./StudyDetailView.vue?vue&type=template&id=7c5a441e&scoped=true"
import script from "./StudyDetailView.vue?vue&type=script&lang=js"
export * from "./StudyDetailView.vue?vue&type=script&lang=js"
import style0 from "./StudyDetailView.vue?vue&type=style&index=0&id=7c5a441e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a441e",
  null
  
)

export default component.exports